import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
import React, { useRef, useEffect } from 'react';
import { StylePropType } from '../../../../services/proptypes';
import { classNames } from '../../../../utils/classname';
import { createComponent } from '../../../foundation/services/components';
import { ANIMATION_STATUS, DEFAULT_ANIMATION_DURATION } from '../../animation.constants';
import useAnimation from '../../hooks/use-animation';
import { getStylesForTransitionProps, getTransition } from '../../services/animation';
import { Transition, TransitionProps } from '../../types/animation.types';
import './AnimatedElement.css';
var defaultProps = {
  duration: DEFAULT_ANIMATION_DURATION,
  transitionProps: {},
  status: undefined,
  easing: 'ease',
  style: {},
  wrap: false,
  className: '',
  animationKey: undefined
};
export default function AnimatedElement(_ref) {
  var _classNames;
  var className = _ref.className,
    children = _ref.children,
    transitionType = _ref.transitionType,
    statusProp = _ref.status,
    duration = _ref.duration,
    transitionProps = _ref.transitionProps,
    easing = _ref.easing,
    wrap = _ref.wrap,
    animationKey = _ref.animationKey;
  var _useRef = useRef(statusProp !== undefined),
    isControlled = _useRef.current;
  if (!transitionType || !children) {
    return children;
  }
  var _useAnimation = useAnimation([transitionType], {
      duration: duration,
      animationKey: animationKey
    }),
    isReady = _useAnimation.isReady,
    state = _useAnimation.state,
    startAnimation = _useAnimation.startAnimation;
  useEffect(function () {
    if (!isControlled) {
      // if uncontrolled animation is triggered when mounted
      if (isReady) {
        startAnimation();
      }
    }
  }, [isReady]);
  var statusDerived = isControlled ? statusProp : state.status;
  var transition = getTransition(duration, easing);
  var parentStyles = _objectSpread(_objectSpread({
    transition: transition
  }, getStylesForTransitionProps(transitionType, statusDerived, transitionProps || {})), {}, {
    WebkitTransition: transition
  });
  var _ref2 = children || {},
    _ref2$props = _ref2.props,
    childrenProps = _ref2$props === void 0 ? {} : _ref2$props;
  var baseClassName = classNames((_classNames = {
    'animated-element': true
  }, _defineProperty(_classNames, transitionType, true), _defineProperty(_classNames, statusDerived, true), _defineProperty(_classNames, className, true), _classNames));
  if (wrap) {
    return /*#__PURE__*/React.createElement("div", {
      style: parentStyles,
      className: baseClassName
    }, children);
  }
  return createComponent(children, _objectSpread(_objectSpread({}, childrenProps), {}, {
    className: "".concat(baseClassName, " ").concat(childrenProps.className || '', " "),
    style: _objectSpread(_objectSpread({}, children.style || {}), parentStyles)
  }));
}
AnimatedElement.defaultProps = defaultProps;